import Vue from "vue";
console.log("【跳题诊断】optionRules.js 模块已加载（新代码已生效）");
const rules = {
  data() {
    return {
      userSelectValues: {},
    };
  },
  methods: {
    initData(flag = true) {
      this.$nextTick(() => {
        console.log(
          "【跳题诊断】initData flag=",
          flag,
          " 字段数:",
          this.formData.length
        );
        this.formData.forEach((item) => {
          if (
            (item.fieldLevel == 1 ||
              item.fieldLevel == 2 ||
              item.fieldLevel == 3) &&
            item.value
          ) {
            console.log(
              "【跳题诊断】initData 处理字段:",
              item.fieldName,
              " value=",
              JSON.stringify(item.value),
              " fieldLevel=",
              item.fieldLevel,
              " 有规则:",
              !!(
                item.rulesInfo &&
                item.rulesInfo.rules &&
                item.rulesInfo.rules.length
              )
            );
            this.valueChange(item, flag);
          }
        });
      });
    },
    valueChange(obj, flag) {
      // 1有条件跳转 2 无条件跳转
      this.$emit("update:rulesJump", 0);
      if (
        !obj ||
        !obj.rulesInfo ||
        !obj.rulesInfo.rules ||
        obj.rulesInfo.rules.length == 0
      )
        return;
      this.goToByRules(obj, flag);
      //如果有值的选项被隐藏 不需要重新设置 防止用户从下往上面填数据
      obj.rulesCode = obj.rulesCode || obj.fieldName;
      this.userSelectValues[obj.rulesCode] = {
        sortBy: obj.sortBy,
        obj: obj,
        rulesCode: obj.rulesCode,
      };
      let gotoItem = null;
      for (let key in this.userSelectValues) {
        gotoItem = this.formData.find((a) => {
          return a.fieldName == this.userSelectValues[key].rulesCode;
        });
        if (
          gotoItem &&
          Number(this.userSelectValues[key].sortBy) > obj.sortBy &&
          gotoItem.isShow
        ) {
          this.goToByRules(this.userSelectValues[key].obj, flag);
        }
      }
    },
    goToByRules(obj, flag) {
      //先恢复数据以免规则相互影响
      this.recoveryData(obj.sortBy);
      if (!obj.value) return;
      // 回填场景 value 是名称数组（如 ["其它"]），规则值是 paramId，统一用转换后的值比较
      if (Array.isArray(obj.value) && obj.ruleValue) {
        obj.value = obj.ruleValue;
      }
      console.log(
        "【跳题诊断】goToByRules 开始计算:",
        obj.fieldName,
        " value=",
        JSON.stringify(obj.value),
        " rulesType=",
        obj.rulesInfo.rulesType,
        " displayType=",
        obj.displayType,
        " flag=",
        flag
      );
      if (obj.rulesInfo.rulesType == 2) {
        //日期 文件 图片都是无条件跳转
        for (let item of obj.rulesInfo.rules) {
          this.goTo(item.rulesJump, obj.sortBy, item.rulesGoto);
          break;
        }
      } else if (obj.rulesInfo.rulesType == 1) {
        for (let item of obj.rulesInfo.rules) {
          //rulesJump 1正常结束 2提前结束 3跳转到相应题目
          // rulesCondition 1等于/选中 [选中是完全等于]2包含/未选中
          // displayType：1单行 2多行 3单选 4下拉单选 5多选 6下拉多选 7 图片 8 文件  9 单选图片 10 多选图片
          if (
            obj.displayType == 1 ||
            obj.displayType == 2 ||
            obj.displayType == 3 ||
            obj.displayType == 4 ||
            obj.displayType == 5 ||
            obj.displayType == 6 ||
            obj.displayType == 9 ||
            obj.displayType == 10
          ) {
            //1等于/选中 [选中是完全等于]2包含/未选中
            if (
              obj.displayType == 5 ||
              obj.displayType == 6 ||
              obj.displayType == 10
            ) {
              if (flag) {
                obj.value = obj.ruleValue.split(",").sort().join(",");
              } else {
                obj.value = obj.value.split(",").sort().join(",");
              }
              item.rulesSelect = item.rulesSelect.split(",").sort().join(",");
            }
            console.log(
              "【跳题诊断】规则比较:",
              obj.fieldName,
              " 当前值=",
              JSON.stringify(obj.value),
              " 规则值=",
              JSON.stringify(item.rulesSelect),
              " 条件类型=",
              item.rulesCondition
            );
            if (item.rulesCondition == 1) {
              if (obj.value == item.rulesSelect) {
                this.goTo(item.rulesJump, obj.sortBy, item.rulesGoto);
                break;
              }
            } else if (item.rulesCondition == 2) {
              if (obj.displayType == 1 || obj.displayType == 2) {
                if (obj.value.indexOf(item.rulesSelect) > -1) {
                  this.goTo(item.rulesJump, obj.sortBy, item.rulesGoto);
                  break;
                }
              } else {
                if (
                  (obj.displayType == 3 ||
                    obj.displayType == 4 ||
                    obj.displayType == 9) &&
                  obj.value != item.rulesSelect
                ) {
                  this.goTo(item.rulesJump, obj.sortBy, item.rulesGoto);
                  break;
                }
                if (
                  (obj.displayType == 5 ||
                    obj.displayType == 6 ||
                    obj.displayType == 10) &&
                  obj.value.indexOf(item.rulesSelect) == -1
                ) {
                  this.goTo(item.rulesJump, obj.sortBy, item.rulesGoto);
                  break;
                }
              }
            }
          }
        }
      }
    },
    goTo(rulesJump, sortBy, rulesGoto) {
      //rulesJump 1正常结束 2提前结束 3跳转到相应题目
      console.log(
        "【跳题诊断】命中规则 goTo 跳转类型=",
        rulesJump,
        " 题序=",
        sortBy,
        " 跳到字段=",
        rulesGoto
      );
      this.$emit("update:rulesJump", rulesJump);
      if (rulesJump == 2) {
        this.goToEnd(sortBy);
      } else if (rulesJump == 3) {
        this.goToSelectCode(sortBy, rulesGoto);
      }
    },
    recoveryData(sortBy) {
      this.formData.forEach((item, index) => {
        if (item.sortBy > sortBy) {
          item.isShow = item.isOldShow;
          Vue.set(this.formData, index, item);
        }
      });
    },
    goToEnd(sortBy) {
      this.formData.forEach((item, index) => {
        if (item.sortBy > sortBy) {
          item.isShow = false;
          Vue.set(this.formData, index, item);
        }
      });
    },
    goToSelectCode(sortBy, rulesGoto) {
      let goItem = this.formData.find((a) => a.fieldName == rulesGoto);
      console.log(
        "【跳题诊断】goToSelectCode 目标题=",
        rulesGoto,
        " 找到:",
        !!goItem,
        goItem ? " 目标当前isShow=" + goItem.isShow : ""
      );
      if (goItem) {
        this.formData.forEach((item, index) => {
          if (item.sortBy > sortBy && item.sortBy < goItem.sortBy) {
            item.isShow = false;
            Vue.set(this.formData, index, item);
          }
          if (item.sortBy == goItem.sortBy) {
            item.isShow = true;
            Vue.set(this.formData, index, item);
          }
        });
      }
    },
  },
};
export default rules;
